// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App_container__Rt8T2 {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-bottom: 20px;
}

.App_app__zr1wm {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.App_contentContainer__3gsZa {
  flex: 1 1;
  padding-bottom: 60px; /* Adjust this value according to the height of your footer */
}

.App_header__fhC8n {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #002352;
  padding: 18px; /* Changed from 1.5rem */
  font-size: 18px; /* Changed from 18.75px */
  font-weight: bold;
  color: white;
}

.App_header__fhC8n a {
  color: white;
  margin-left: 15px;
  text-decoration: none;
}

.App_header__fhC8n a:hover {
  text-decoration: underline;
}

.App_title__YS7Xx {
  font-size: 24px !important;
  font-weight: bold !important;
  color: black !important;
  margin: 18px 0; /* Changed from 1.5rem 0 */
  padding-top: 15px;
  padding-bottom: 15px;
  text-align: center;
}

.App_main__nhgh3 {
  flex-grow: 1;
  padding: 9px; /* Changed from 0.75rem */
  padding-bottom: 45px;
}

.App_gridContainer__ALkEu {
  margin-top: 112px; /* Changed from 112.5px */
}

.App_paper__8CPy4 {
  padding: 20px;
  margin: 10px 0;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.3s,
    box-shadow 0.3s;
}

.App_paper__8CPy4:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.App_paper__8CPy4 .App_boxHeading__206xL {
  color: black;
  text-align: center;
}

.App_paper__8CPy4 .App_boxText__vmGFo {
  color: black;
  text-align: center;
  margin: 5px 0;
  padding: 5px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.1);
}

.App_paper__8CPy4 .App_boldText__MjNhU {
  font-size: 15px;
  color: white;
  background-color: #0066cc;
  display: inline-block;
  padding: 4px 8px; /* Changed from 3.75px 7.5px */
  border-radius: 4px; /* Changed from 3.75px */
  margin: 8px 0; /* Changed from 7.5px 0 */
  text-align: center;
  width: 90%;
  font-weight: bold;
}

.App_paper__8CPy4 h1 {
  color: black;
  font-size: 15px;
  font-weight: bold;
}

.App_paper__8CPy4 h2 {
  color: white;
  font-size: 15px;
  font-weight: 800;
}

.App_paper__8CPy4 p {
  color: black;
  font-size: 12px;
}

.App_centerText__c8SVs {
  text-align: center;
}

.App_footer__aawhi {
  position: relative;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #0066cc;
  padding: 9px; /* Changed from 0.75rem */
  text-align: center;
  color: white;
}

.App_footerLinks__yxDPS {
  display: flex;
  justify-content: space-around;
  margin-bottom: 4px; /* Changed from 0.375rem */
}

.App_footerLink__UPoa1 {
  color: white;
  text-decoration: none;
}

.App_footerLink__UPoa1:hover {
  text-decoration: underline;
}

.App_divider__8SMQv {
  border: 0;
  height: 1px;
  background: #cccccc;
  margin-bottom: 4px; /* Changed from 0.375rem */
}

.App_paragraph__HkgxP {
  margin-top: 15px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/App.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,oBAAoB,EAAE,6DAA6D;AACrF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,aAAa,EAAE,wBAAwB;EACvC,eAAe,EAAE,yBAAyB;EAC1C,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,uBAAuB;EACvB,cAAc,EAAE,0BAA0B;EAC1C,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY,EAAE,yBAAyB;EACvC,oBAAoB;AACtB;;AAEA;EACE,iBAAiB,EAAE,yBAAyB;AAC9C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,wCAAwC;EACxC;;mBAEiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB,EAAE,8BAA8B;EAChD,kBAAkB,EAAE,wBAAwB;EAC5C,aAAa,EAAE,yBAAyB;EACxC,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,YAAY,EAAE,yBAAyB;EACvC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,kBAAkB,EAAE,0BAA0B;AAChD;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,kBAAkB,EAAE,0BAA0B;AAChD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  padding-bottom: 20px;\n}\n\n.app {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.contentContainer {\n  flex: 1;\n  padding-bottom: 60px; /* Adjust this value according to the height of your footer */\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #002352;\n  padding: 18px; /* Changed from 1.5rem */\n  font-size: 18px; /* Changed from 18.75px */\n  font-weight: bold;\n  color: white;\n}\n\n.header a {\n  color: white;\n  margin-left: 15px;\n  text-decoration: none;\n}\n\n.header a:hover {\n  text-decoration: underline;\n}\n\n.title {\n  font-size: 24px !important;\n  font-weight: bold !important;\n  color: black !important;\n  margin: 18px 0; /* Changed from 1.5rem 0 */\n  padding-top: 15px;\n  padding-bottom: 15px;\n  text-align: center;\n}\n\n.main {\n  flex-grow: 1;\n  padding: 9px; /* Changed from 0.75rem */\n  padding-bottom: 45px;\n}\n\n.gridContainer {\n  margin-top: 112px; /* Changed from 112.5px */\n}\n\n.paper {\n  padding: 20px;\n  margin: 10px 0;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  transition:\n    transform 0.3s,\n    box-shadow 0.3s;\n}\n\n.paper:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.paper .boxHeading {\n  color: black;\n  text-align: center;\n}\n\n.paper .boxText {\n  color: black;\n  text-align: center;\n  margin: 5px 0;\n  padding: 5px;\n  border-radius: 4px;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.paper .boldText {\n  font-size: 15px;\n  color: white;\n  background-color: #0066cc;\n  display: inline-block;\n  padding: 4px 8px; /* Changed from 3.75px 7.5px */\n  border-radius: 4px; /* Changed from 3.75px */\n  margin: 8px 0; /* Changed from 7.5px 0 */\n  text-align: center;\n  width: 90%;\n  font-weight: bold;\n}\n\n.paper h1 {\n  color: black;\n  font-size: 15px;\n  font-weight: bold;\n}\n\n.paper h2 {\n  color: white;\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.paper p {\n  color: black;\n  font-size: 12px;\n}\n\n.centerText {\n  text-align: center;\n}\n\n.footer {\n  position: relative;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: #0066cc;\n  padding: 9px; /* Changed from 0.75rem */\n  text-align: center;\n  color: white;\n}\n\n.footerLinks {\n  display: flex;\n  justify-content: space-around;\n  margin-bottom: 4px; /* Changed from 0.375rem */\n}\n\n.footerLink {\n  color: white;\n  text-decoration: none;\n}\n\n.footerLink:hover {\n  text-decoration: underline;\n}\n\n.divider {\n  border: 0;\n  height: 1px;\n  background: #cccccc;\n  margin-bottom: 4px; /* Changed from 0.375rem */\n}\n\n.paragraph {\n  margin-top: 15px;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `App_container__Rt8T2`,
	"app": `App_app__zr1wm`,
	"contentContainer": `App_contentContainer__3gsZa`,
	"header": `App_header__fhC8n`,
	"title": `App_title__YS7Xx`,
	"main": `App_main__nhgh3`,
	"gridContainer": `App_gridContainer__ALkEu`,
	"paper": `App_paper__8CPy4`,
	"boxHeading": `App_boxHeading__206xL`,
	"boxText": `App_boxText__vmGFo`,
	"boldText": `App_boldText__MjNhU`,
	"centerText": `App_centerText__c8SVs`,
	"footer": `App_footer__aawhi`,
	"footerLinks": `App_footerLinks__yxDPS`,
	"footerLink": `App_footerLink__UPoa1`,
	"divider": `App_divider__8SMQv`,
	"paragraph": `App_paragraph__HkgxP`
};
export default ___CSS_LOADER_EXPORT___;
